import React, { useEffect, useState } from 'react';
import { CatalogueOperation } from 'pages/catalogues/catalogue-operation.enum';
import { CatalogueExtended } from 'api/query/catalogue/catalogue-extended';
import catalogueApi from 'api/query/catalogue';
import LoadContainer from 'components/load-container';
import { EditProps } from './edit-props';
import CreateCatalogueForm from '../create-catalogue-form';

/**
 * Edit an existing or draft catalogue.
 */
export const Edit: React.FC<EditProps> = (props) => {
  const {
    catalogue,
    id,
    db,
  } = props;

  const [cata, setCata] = useState<CatalogueExtended>(catalogue as CatalogueExtended);

  useEffect(() => {
    if (catalogue) {
      setCata(catalogue);
    }
  }, [catalogue]);

  /**
   * Gets the catalogue for the id if a catalogue wasn't provided as a prop.
   */
  useEffect(() => {
    if (!cata && id) {
      const getCatalogue = async () => {
        const response = await catalogueApi.getById(id, db);
        setCata(response);
      };

      getCatalogue();
    }
  }, [cata, db, id]);

  return (
    <LoadContainer
      loading={!cata}
    >
      <CreateCatalogueForm
        {...props}
        catalogue={cata}
        id={id}
        operation={CatalogueOperation.Edit}
      />
    </LoadContainer>
  );
};
